import Calculator from "./Calculator";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "../main.css";
// import Admin from "./Admin";

function App() {
  return (
    <div id="content">
      <BrowserRouter>
        <div id="resizeClassName">
          <Switch>
            <Route exact path="/">
              <Calculator />
            </Route>
          </Switch>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
